module.exports = __webpack_public_path__ + "static/media/coin.834e7998.PNG";